import { COUNTER_VALUE } from '_config/constants'

export const getCounterValue = settings => {
  const userCounterValue = settings.get('timeInterval')
    ? settings.get('timeInterval') * 60
    : COUNTER_VALUE
  return userCounterValue
}

export const getMindfulBreakDuration = (mindfulBreaks, name) => {
  const mindfulBreak = mindfulBreaks.filter(pause => pause.name === name).first()
  if (mindfulBreak) {
    return mindfulBreak.duration
  }
  return 0
}



// WEBPACK FOOTER //
// ./src/utils/counter.js